import * as destinationPackageDeliveryService from "../../../services/destinationPackageDelivery";
import * as settings from "../../../services/settings";

import { ArrowLeftOutlined, DeleteOutlined, EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Card, Col, Input, Row, Select, Spin, Table, Typography, notification } from "antd";
import { useCallback, useEffect, useState } from "react";

import { Form } from "antd";
import { ModalDelete } from "../../../Components/model/modal/delete";
import dayjs from "dayjs";
import { formatDeliveryStatusLabel } from "../../../utils/deliveryStatusLabel";
import permissions from "../../../../configs/permission";
import { useAccessToken } from "../../../contexts/AccessTokenContext";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../../../hooks/usePermission";
import { useTranslation } from "react-i18next";

const initPage = { limit: 10, page: 1 };

let promise;
export const DestinationPackageDeliveryPage = () => {
  const EXPORT_ALL_MAX = 5000;
  const { hasPermission, isSuperuser } = usePermission();
  const { accessToken } = useAccessToken();
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation("destinationpackagedelivery", "buttons", "common");
  const { t: tOps } = useTranslation("options", { keyPrefix: "Package" });
  const [search, setSearch] = useState(initPage);
  const [destinationPackageDeliveryData, setDestinationPackageDeliveryData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowsValues, setSelectedRowsValues] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { Title, Link } = Typography;
  const { Search } = Input;
  const [total, setTotal] = useState(0);
  const [countSelect, setCountSelect] = useState(0);
  const [isOpenButton, setIsOpenButton] = useState(false);
  const [isOpenExport, setIsOpenExport] = useState(false);
  const [isSelectAllMode, setIsSelectAllMode] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, value) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRowsValues(value);
      setCountSelect(selectedRowKeys.length);
      setIsOpenButton(selectedRowKeys.length > 0);
      setIsOpenExport(selectedRowKeys.length === 0);
      setIsSelectAllMode(false);
    },
  };

  const onHandleUpdateStatus = async () => {
    setLoading(true);
    try {
      let idsForUpdate = selectedRowKeys;

      if (isSelectAllMode && idsForUpdate.length === 0 && countSelect > 0) {
        const totalCount = Number(total) || 0;
        const batchLimit = 1000;
        const totalPages = Math.max(1, Math.ceil(totalCount / batchLimit));
        const allIds = [];

        for (let page = 1; page <= totalPages; page += 1) {
          const response = await destinationPackageDeliveryService.getAllDestinationPackageDelivery(accessToken, {
            reference: search.reference || undefined,
            delivery_status: search.delivery_status !== "all" ? search.delivery_status : undefined,
            page,
            limit: batchLimit,
          });
          const rows = response?.queryDestinationDeliveryPackage || [];
          allIds.push(...rows.map((row) => row.id).filter(Boolean));
        }

        idsForUpdate = [...new Set(allIds)];
      }

      if (idsForUpdate.length === 0) {
        openNotificationWithIcon(
          settings.NotificationType.WARNING,
          t("Warning", { ns: "common" }),
          "Please select at least one item."
        );
        return;
      }

      let prepareDeleteDestinationPackageDelivery = {
        ids: idsForUpdate,
      };

      const response = await destinationPackageDeliveryService.updateStatusDestinationDeliveryPackage(
        accessToken,
        prepareDeleteDestinationPackageDelivery
      );
      setSelectedRowKeys([]);
      setCountSelect(0);
      setIsOpenExport(false);
      setIsSelectAllMode(false);
      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        <>{"Success."}</>,
        <>{"Update destination package delivery success."}</>
      );
      fetchDestinationPackageDelivery({ ...search });
      setLoading(false);
      setIsOpenButton(false);
    } catch (err) {
      console.error("[DestinationPackageDeliveryPage] onHandleUpdateStatus: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
    } finally {
      setLoading(false);
    }
  };

  const onDeleteDestinationPackageDelivery = async (data) => {
    let prepareDeleteDestinationPackageDelivery = {
      id: data.id,
    };
    try {
      const response = await destinationPackageDeliveryService.deleteDestinationDeliveryPackage(
        accessToken,
        prepareDeleteDestinationPackageDelivery
      );
      openNotificationWithIcon(
        settings.NotificationType.SUCCESS,
        <>{"Success."}</>,
        <>{"Delete destination package delivery success."}</>
      );
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      clearSelection();
      fetchDestinationPackageDelivery({ ...search });
      setLoading(false);
    } catch (err) {
      console.error("[DestinationPackageDeliveryPage] onDeleteDestinationPackageDelivery: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const fetchDestinationPackageDelivery = useCallback(
    async (param) => {
      try {
        const data = await destinationPackageDeliveryService.getAllDestinationPackageDelivery(accessToken, param);
        setTotal(data.totalCount);
        setDestinationPackageDeliveryData(data.queryDestinationDeliveryPackage);
        setSearch({ ...param });
      } catch (err) {
        console.error("[DestinationPackageDeliveryPage] fetchDestinationPackageDelivery: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      }
    },
    [accessToken]
  );

  const onFinish = async (fieldsValues) => {
    onSearch({ ...fieldsValues, page: 1 });
  };
  const onSearch = async (values) => {
    setLoading(true);
    try {
      clearSelection();
      const param = {
        reference: values.reference || undefined,
        delivery_status: values.delivery_status !== "all" ? values.delivery_status : undefined,
        page: values.page || search.page,
        limit: values.limit || search.limit,
      };
      await fetchDestinationPackageDelivery(param);
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    form.resetFields();
    const param = {
      reference: undefined,
      delivery_status: undefined,
      page: search.page,
      limit: search.limit,
    };
    onSearch(param);
  };

  const initialValues = {
    reference: undefined,
    delivery_status: "all",
  };

  const selectDeliveryStatus = [
    { value: "all", label: tOps("All") },
    { value: "open", label: formatDeliveryStatusLabel("open", i18n.language, tOps) },
    { value: "close", label: formatDeliveryStatusLabel("close", i18n.language, tOps) },
    { value: "deliver", label: formatDeliveryStatusLabel("deliver", i18n.language, tOps) },
    { value: "return", label: formatDeliveryStatusLabel("return", i18n.language, tOps) },
  ];

  const clearSelection = () => {
    setSelectedRowKeys([]);
    setSelectedRowsValues([]);
    setCountSelect(0);
    setIsOpenButton(false);
    setIsOpenExport(false);
    setIsSelectAllMode(false);
  };

  const onSelectAll = async () => {
    const totalCount = Number(String(total).replace(/,/g, ""));
    if (totalCount > EXPORT_ALL_MAX) {
      openNotificationWithIcon(
        settings.NotificationType.WARNING,
        t("Warning", { ns: "common" }),
        t("Export_All_Limit_Error", {
          ns: "error",
          max: EXPORT_ALL_MAX.toLocaleString(),
          count: totalCount.toLocaleString(),
        })
      );
      setCountSelect(EXPORT_ALL_MAX);
      setIsOpenButton(false);
      setIsOpenExport(false);
      setSelectedRowKeys([]);
      setSelectedRowsValues([]);
      setIsSelectAllMode(true);
      return;
    }

    setCountSelect(totalCount);
    setIsOpenButton(totalCount > 0);
    setIsOpenExport(totalCount > 0 ? false : true);
    setSelectedRowKeys([]);
    setSelectedRowsValues([]);
    setIsSelectAllMode(true);
  };

  // Load once when token is ready. Do not depend on `i18n.language`: changing locale re-renders
  // labels via `t()` / `tOps()` and must not refetch with reset filters (would desync form vs table).
  useEffect(() => {
    if (!accessToken) return;
    setIsOpenExport(true);
    onSearch({ ...initPage, delivery_status: "all" });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional: language switch must not reset search
  }, [accessToken]);

  const hasSelected = selectedRowKeys.length > 0;

  const columns = [
    {
      title: t("Destination_Package_Delivery_Table.Table_ID"),
      dataIndex: "id",
      render: (_, record) => (
        <Link
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/package/destinationpackagedelivery/create", {
              state: { type: "EDIT", destinationPackageDeliveryData: record },
            });
          }}
        >
          {record.id}
        </Link>
      ),
    },
    {
      title: t("Destination_Package_Delivery_Table.Table_Destination_Package"),
      dataIndex: "reference",
      render: (_, record) => (
        <p
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/package/destinationpackagedelivery/create", {
              state: { type: "EDIT", destinationPackageDeliveryData: record },
            });
          }}
        >
          {record.app_destinationpackage.reference || "-"}
        </p>
      ),
    },
    {
      title: t("Destination_Package_Delivery_Table.Table_Destination_Delivery"),
      dataIndex: "destination_description",
      render: (_, record) => {
        const delivery_type = record.app_destinationdelivery.delivery_type.toUpperCase() || "";
        let destination_description;
        if (delivery_type === "Normal".toUpperCase()) {
          destination_description = "Normal";
        } else if (delivery_type === "SELF".toUpperCase()) {
          destination_description = "รับเอง";
        } else if (delivery_type === "Private".toUpperCase()) {
          destination_description = "Private";
        } else {
          destination_description = "Express";
        }

        return <p>{destination_description}</p>;
      },
    },
    {
      title: t("Destination_Package_Delivery_Table.Table_Status"),
      dataIndex: "delivery_status",
      render: (_, record) => {
        const label = formatDeliveryStatusLabel(record.delivery_status, i18n.language, tOps);
        if (label == null || label === "") {
          return <p>-</p>;
        }
        return <p>{label}</p>;
      },
    },
    {
      title: t("Destination_Package_Delivery_Table.Table_Total_Received"),
      dataIndex: "total_received",
      render: (_, record) => record.total_received || 0,
    },
    {
      title: t("Destination_Package_Delivery_Table.Table_Total_Sent"),
      dataIndex: "total_sent",
      render: (_, record) => record.total_sent || "-",
    },
    {
      title: t("Create_At", { ns: "common" }),
      dataIndex: "created_at",
      render: (value) => (value ? dayjs(value).format("YYYY-MM-DD hh:mm:ss A") : "-"),
    },
    {
      title: t("Update_At", { ns: "common" }),
      dataIndex: "updated_at",
      render: (value) => (value ? dayjs(value).format("YYYY-MM-DD hh:mm:ss A") : "-"),
    },
    {
      title: t("Edit", { ns: "common" }),
      key: "edit",
      render: (_, row) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.DestinationPackageDelivery.CHANGE)}
          onClick={() => {
            navigate("/package/destinationpackagedelivery/create", {
              state: { type: "EDIT", destinationPackageDeliveryData: row },
            });
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: t("Delete", { ns: "common" }),
      key: "delete",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.DestinationPackageDelivery.DELETE)}
          onClick={() => {
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  const items = [
    { title: t("Page_Body_Tab_Menu.Home", { ns: "menus" }) },
    { title: t("Page_Body_Tab_Menu.Menu", { ns: "menus" }) },
    { title: t("Menu_Package.Title_Package", { ns: "menus" }) },
    {
      title: (
        <a href="/package/destinationpackagedelivery" style={{ fontWeight: 600, color: "black" }}>
          {t("Menu_Package.Destination_Package_Delivery", { ns: "menus" })}
        </a>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row flex={1}>
          <Col span={24}>
            <Breadcrumb items={items} />
            <Row style={{ padding: "15px 0px" }}>
              <Col span={12}>
                <Title
                  level={4}
                  style={{
                    textWrap: "nowrap",
                    display: "flex",
                    gap: "7px",
                  }}
                >
                  <ArrowLeftOutlined style={{ fontSize: "20px" }} />
                  {t("Menu_Package.Destination_Package_Delivery", { ns: "menus" })}
                </Title>
              </Col>
            </Row>
          </Col>
        </Row>
        {/*Form Search*/}
        <Row style={{ display: "flex", justifyContent: "left", overflowX: "auto" }}>
          <Col span={12}>
            <Form
              form={form}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              labelAlign="left"
              layout="horizontal"
              onFinish={onFinish}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  form.submit();
                }
              }}
              initialValues={initialValues}
            >
              <Form.Item label={t("Search", { ns: "common" })} name="reference" key="reference">
                <Input placeholder="Destination package" style={{ minWidth: 200 }} />
              </Form.Item>
              <Form.Item label={t("Delivery_Status")} name="delivery_status" key="delivery_status">
                <Select
                  style={{ width: "100%", minWidth: 200 }}
                  placeholder="Delivery Status"
                  options={selectDeliveryStatus}
                />
              </Form.Item>
              <Row justify="end" align="middle">
                <Col span={24} style={{ textAlign: "end" }}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      {t("BTN_Search", { ns: "buttons" })}
                    </Button>
                    <Button type="default" onClick={() => reset()} style={{ marginLeft: "5px" }}>
                      {t("BTN_Reset", { ns: "buttons" })}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <Row justify="end" style={{ marginBottom: "10px" }}>
          <Col>
            <Row gutter={16}>
              <Col>
                {/* close export button because wait requirement. */}
                {/* {hasPermission(permissions.DestinationPackageDelivery.EXPORT) && (
                  <Button disabled={isOpenExport} type="primary">
                    {t("BTN_Export_Excel", { ns: "buttons" })}
                  </Button>
                )} */}
              </Col>
              <Col>
                <Button
                  disabled={!isOpenButton}
                  type="primary"
                  icon={<PlusCircleOutlined />}
                  onClick={onHandleUpdateStatus}
                >
                  {t("Button_Destination_Package_Delivery.BTN_Add")}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col span={24}>
            <Row align="middle" justify="center">
              <Col span={24}>
                {`${t("Select", { ns: "common" })}: ${countSelect} to ${total}`}&nbsp;
                <Link onClick={onSelectAll} target="_blank">
                  {t("Select_All", { ns: "common" })}
                </Link>
              </Col>
            </Row>
            <Card>
              <Table
                loading={loading}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={destinationPackageDeliveryData}
                scroll={{ x: "max-content" }}
                rowKey={(record) => record.id}
                pagination={{
                  defaultPageSize: search.limit,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  current: search.page,
                  pageSize: search.limit,
                  total: total,
                  onChange: (page, limit) => {
                    onSearch({ ...search, page, limit });
                  },
                  showSizeChanger: true,
                }}
                style={{ cursor: "pointer" }}
              />
            </Card>
          </Col>
        </Row>
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            onDeleteDestinationPackageDelivery(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
